import { defaultFont, dangerColor } from 'assets/jss/material-dashboard-pro-react';

const topUpCardStyle = (theme) => ({
	topupCard: {
		width: '100%',
		marginBottom: 24,
	},
	headerContainer: {
		'& > div:nth-of-type(2)': {
			textAlign: 'center',
		},
		[theme.breakpoints.down('sm')]: {
			'& > div > div': {
				justifyContent: 'center',
			},
			'& > div > p': {
				textAlign: 'center',
			},
		},
	},
	alignRight: {
		textAlign: 'right',
	},
	customTopUpInput: {
		width: '60%',
		marginTop: 5,
		'& p': {
			textAlign: 'right !important',
		},
	},
	customInput: {
		paddingTop: 0,
		margin: '0 0 0 auto',
		'& input': {
			...defaultFont,
			fontSize: 18,
			lineHeight: '24px',
			textAlign: 'right',
			padding: '10px 8px 6px',
		},
	},
	marginValue: {
		marginTop: theme.direction === 'rtl' ? 12 : 18,
	},
	totalAmountContainer: {
		display: 'flex',
		'& > p:first-of-type': {
			textAlign: 'left',
		},
	},
	dangerColor: {
		'& > p': {
			color: dangerColor[0],
		},
		'& > div': {
			borderColor: dangerColor[0],
		},
		'& > div:last-of-type p': {
			color: dangerColor[0],
		},
	},
	divider: {
		display: 'inline-flex',
		width: '33.96px',
		height: '0px',
		margin: '0 -8px',
		borderBottom: '1.6px solid rgba(0, 0, 0, 0.85)',
		transform: 'rotate(103.63deg)',
		position: 'relative',
		top: '20px',
	},
	creditLimitContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'baseline',
	},
	topupValueContainer: {
		display: 'flex',
		textAlign: 'center',
	},
	singleTopupValueWrapper: {
		'& button': {
			height: 48,
			minWidth: 48,
			marginRight: 8,
			marginLeft: 0,
			fontSize: theme.fontSize(28),
		},
	},
});

export default topUpCardStyle;
